import { FC } from 'react'

import { t } from 'translations'
import styles from './loading.module.scss'

const Loading: FC<{ noInternet?: boolean }> = ({ noInternet = false }) => {
  return (
    <div className={` ${styles['app-loading']} animated-container`}>
      <div id="loader-wrapper">
        <div id="loader"></div>
        <div className="loader-section section-left"></div>
        <div className="loader-section section-right"></div>
        {noInternet ? (
          <div className={`text-center ${styles['loading-text-container']} pt-3`}>
            <div className={styles['loading-text']}>{t('NO_INTERNET_ACCESS')}</div>
            <div className={`${styles['loading-text']} ${styles['limit-width']}`}>{t('WILL_RESUME_WHEN_INTERNET_AVAILABLE')}</div>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export { Loading }
